import React, { useState } from 'react'
import PropTypes from 'prop-types'

import styles from './style.module.scss'

import MyImage from '@shared/components/myImage'
import TeamImage from '@assets/images/placeholder/team-placeholder.svg'
// import flash from '@assets/images/icon/flash-icon.svg'
import { Accordion } from 'react-bootstrap'
import { S3_PREFIX } from '@shared-submodule/sm-constants'
import { useRouter } from 'next/router'

const TeamForm = ({ matchDetail, teamA, teamB, activeKey, isMobile }) => {
  const router = useRouter()
  const [border, setBorder] = useState({
    borderBtm1: false,
    borderBtm2: false
  })

  const handleClick = slug => {
    if (slug && !isMobile) {
      router.push(`/${slug}`)
    }
  }

  const toggleBorder = name => {
    setBorder({ [name]: !border?.[name] })
  }

  return (
    <section className="mb-3 content-visibility-auto">
      <h6 className="font-bold mt-0">{'Team Form'}</h6>
      <Accordion defaultActiveKey={activeKey ? '' : '0'} className={`${styles.teamForm} overflow-hidden`}>
        {teamA && teamA?.length > 0 && (
          <Accordion.Item eventKey="0" className={`${styles.item} overflow-hidden mb-2`}>
            <Accordion.Header
              className={`${styles.head} ${!border?.borderBtm1 && 'border-bottom-0'}`}
              onClick={() => toggleBorder('borderBtm1')}>
              <div className={`${styles.teamHead} d-flex align-items-center`}>
                <div className={`${styles.teamImg} me-2 me-md-3 overflow-hidden flex-shrink-0`}>
                  <MyImage
                    placeholderImage={TeamImage}
                    src={
                      matchDetail?.oTeamScoreA?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${matchDetail?.oTeamScoreA?.oTeam?.oImg?.sUrl}` : TeamImage
                    }
                    layout="responsive"
                    width="20"
                    height="20"
                    autoRadiusImage
                    alt={matchDetail?.oTeamScoreA?.oTeam?.sAbbr}
                  />
                </div>
                <p className="d-none d-sm-block mb-0 me-md-0">
                  {matchDetail?.oTeamScoreA?.oTeam?.sTitle || matchDetail?.oTeamScoreA?.oTeam?.sAbbr}
                </p>
                <p className="d-sm-none mb-0 me-md-0">
                  {matchDetail?.oTeamScoreA?.oTeam?.sAbbr || matchDetail?.oTeamScoreA?.oTeam?.sTitle}
                </p>
              </div>
              <div className={`${styles.matchList} d-flex align-items-center ms-auto`}>
                {/* <div className={`${styles.status} ${styles.star} text-center rounded-circle flex-shrink-0 small-text`}>*</div> */}
                {teamA?.map((match, index) => {
                  return (
                    <div
                      key={index}
                      className={`${styles.status} ${
                        !match?.oWinner?._id ? '' : match?.oWinner?._id === matchDetail?.oTeamScoreA?.oTeam?._id ? styles.win : styles.loss
                      } text-center rounded-circle flex-shrink-0 small-text`}>
                      {!match?.oWinner?._id ? 'N' : match?.oWinner?._id === matchDetail?.oTeamScoreA?.oTeam?._id ? 'W' : 'L'}
                    </div>
                  )
                })}
              </div>
            </Accordion.Header>
            <Accordion.Body className={`${styles.content} mt-0 pt-0`}>
              {teamA?.map((match, index) => {
                const is100 = match?.oFormat?.sValue?.includes('t100')
                return (
                  <div
                    key={index}
                    className={`${styles.itemSm} d-flex align-items-center mx-3`}
                    onClick={() => handleClick(match?.oSeo?.sSlug)}>
                    <div className={`${styles.team} me-1`}>
                      <p className="mb-0">{match?.oTeamScoreA?.oTeam?.sAbbr || match?.oTeamScoreA?.oTeam?.sTitle}</p>
                      <p className="mb-0 me-md-0">
                        <span className="mb-0 font-bold">{`${match?.oTeamScoreA?.sScores} `}</span>
                        {`(${match?.oTeamScoreA?.sOvers} ${is100 ? 'b' : 'ov'})`}
                      </p>
                    </div>
                    <p className={`${styles.result} text-muted flex-grow-1 text-center mb-0`}>{match?.sResult || match?.sStatusNote}</p>
                    <div className={`${styles.team} ms-1 text-end`}>
                      <p className="mb-0 ms-1">{match?.oTeamScoreB?.oTeam?.sAbbr || match?.oTeamScoreB?.oTeam?.sTitle}</p>
                      <p className="mb-0 me-md-0">
                        <span className="mb-0 font-bold">{`${match?.oTeamScoreB?.sScores} `}</span>
                        {`(${match?.oTeamScoreB?.sOvers} ${is100 ? 'b' : 'ov'})`}
                      </p>
                    </div>
                  </div>
                )
              })}
            </Accordion.Body>
          </Accordion.Item>
        )}
        {teamB && teamB?.length > 0 && (
          <Accordion.Item eventKey="1" className={`${styles.item} overflow-hidden`}>
            <Accordion.Header
              className={`${styles.head} ${!border.borderBtm2 && 'border-bottom-0'}`}
              onClick={() => toggleBorder('borderBtm2')}>
              <div className={`${styles.teamHead} d-flex align-items-center`}>
                <div className={`${styles.teamImg} me-2 me-md-3 overflow-hidden flex-shrink-0`}>
                  <MyImage
                    placeholderImage={TeamImage}
                    src={
                      matchDetail?.oTeamScoreB?.oTeam?.oImg?.sUrl ? `${S3_PREFIX}${matchDetail?.oTeamScoreB?.oTeam?.oImg?.sUrl}` : TeamImage
                    }
                    layout="responsive"
                    width="20"
                    height="20"
                    autoRadiusImage
                    alt={matchDetail?.oTeamScoreB?.oTeam?.sAbbr}
                  />
                </div>
                <p className="mb-0 me-md-0">{matchDetail?.oTeamScoreB?.oTeam?.sTitle || matchDetail?.oTeamScoreB?.oTeam?.sAbbr}</p>
              </div>
              <div className={`${styles.matchList} d-flex align-items-center ms-auto`}>
                {/* <div className={`${styles.status} text-center rounded-circle flex-shrink-0 small-text`}>*</div> */}
                {/* <div className={`${styles.status} ${styles.star} text-center rounded-circle flex-shrink-0 small-text`}>*</div> */}
                {teamB?.map((match, index) => {
                  return (
                    <div
                      key={index}
                      className={`${styles.status} ${
                        !match?.oWinner?._id ? '' : match?.oWinner?._id === matchDetail?.oTeamScoreB?.oTeam?._id ? styles.win : styles.loss
                      } text-center rounded-circle flex-shrink-0 small-text`}>
                      {!match?.oWinner?._id ? 'N' : match?.oWinner?._id === matchDetail?.oTeamScoreB?.oTeam?._id ? 'W' : 'L'}
                    </div>
                  )
                })}
              </div>
            </Accordion.Header>
            <Accordion.Body className={`${styles.content} mt-0`}>
              {teamB?.map((match, index) => {
                const is100 = match?.oFormat?.sValue?.includes('t100')
                return (
                  <div
                    key={index}
                    className={`${styles.itemSm} d-flex align-items-center mx-3`}
                    onClick={() => handleClick(match?.oSeo?.sSlug)}>
                    <div className={`${styles.team} me-1`}>
                      <p className="mb-0">{match?.oTeamScoreA?.oTeam?.sAbbr || match?.oTeamScoreA?.oTeam?.sTitle}</p>
                      <p className="mb-0 me-md-0">
                        <span className="mb-0 font-bold">{`${match?.oTeamScoreA?.sScores} `}</span>
                        {`(${match?.oTeamScoreA?.sOvers} ${is100 ? 'b' : 'ov'})`}
                      </p>
                    </div>
                    <p className={`${styles.result} text-muted flex-grow-1 text-center mb-0`}>{match?.sResult || match?.sStatusNote}</p>
                    <div className={`${styles.team} ms-1 text-end`}>
                      <p className="mb-0 ms-1">{match?.oTeamScoreB?.oTeam?.sAbbr || match?.oTeamScoreB?.oTeam?.sTitle}</p>
                      <p className="mb-0 me-md-0">
                        <span className="mb-0 font-bold">{`${match?.oTeamScoreB?.sScores} `}</span>
                        {`(${match?.oTeamScoreB?.sOvers} ${is100 ? 'b' : 'ov'})`}
                      </p>
                    </div>
                  </div>
                )
              })}
            </Accordion.Body>
          </Accordion.Item>
        )}
      </Accordion>
    </section>
  )
}
TeamForm.propTypes = {
  matchDetail: PropTypes.object,
  teamA: PropTypes.array,
  teamB: PropTypes.array,
  status: PropTypes.string,
  activeKey: PropTypes.bool,
  isMobile: PropTypes.bool,
  is100: PropTypes.bool
}

export default TeamForm
